import { render, staticRenderFns } from "./accountSettingMobile.vue?vue&type=template&id=15149521&scoped=true&"
import script from "./accountSettingMobile.vue?vue&type=script&lang=js&"
export * from "./accountSettingMobile.vue?vue&type=script&lang=js&"
import style0 from "./accountSettingMobile.vue?vue&type=style&index=0&id=15149521&prod&scoped=true&lang=css&"
import style1 from "./accountSettingMobile.vue?vue&type=style&index=1&id=15149521&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15149521",
  null
  
)

export default component.exports